(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dof-legal-link-hub"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-dof-cookie-preferences]');

    if (!trigger) {
      return;
    }

    event.preventDefault();

    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
      return;
    }

    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.showPreferences === 'function'
    ) {
      window.Shopify.customerPrivacy.showPreferences();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
